import React from 'react';
import { Button, Dialog, Slide } from '@material-ui/core';
import PropTypes from 'prop-types';

// Icons
import ClearIcon from '@material-ui/icons/Clear';
import EditIcon from '@material-ui/icons/Edit';

// Redux
import { connect } from 'react-redux';

// Constants
import { UserTypes } from '../constants';
import { T } from '../constants/tokens';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='up' ref={ref} {...props} />;
});

/**
 * The detail panel as a full-screen sheet, for viewports too narrow to show it
 * beside the content.
 *
 * Mirrors InfoPanel: same header / body / footer structure, same white
 * surface and hairline rules, same short status accent under the header. The
 * two are kept in step by hand rather than shared because one is a card in a
 * grid cell and the other is a sheet that owns the screen.
 */
function InfoDialog({ children, statusColor, header = null, footer = null, open, handleClose, editHref = null, showEdit }) {
  return (
    <Dialog fullScreen open={open} onClose={handleClose} TransitionComponent={Transition}>
      <div
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          background: T.surfaceCard,
          minHeight: 0
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'flex-start',
            gap: 12,
            padding: '16px 16px 12px',
            borderBottom: '1px solid ' + T.hairline
          }}
        >
          <div style={{ flex: 1, minWidth: 0 }}>
            {header}
            {statusColor &&
              <div
                style={{
                  height: 3,
                  borderRadius: 9999,
                  width: 40,
                  marginTop: 12,
                  background: statusColor
                }}
              />}
          </div>
          <button
            type='button'
            aria-label='Close'
            onClick={handleClose}
            style={{
              width: 36,
              height: 36,
              flex: 'none',
              borderRadius: 9999,
              border: '1px solid ' + T.hairline,
              background: T.elevated,
              color: T.ink,
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: 0
            }}
          >
            <ClearIcon style={{ fontSize: 18 }} />
          </button>
        </div>

        <div style={{ flex: 1, minHeight: 0, overflowY: 'auto', padding: 16 }}>
          {children}
        </div>

        {(footer || (editHref && showEdit)) &&
          <div style={{ padding: 16, borderTop: '1px solid ' + T.hairline }}>
            {footer}
            {editHref && showEdit &&
              <Button
                variant='outlined'
                href={editHref}
                fullWidth
                style={{ marginTop: footer ? 12 : 0 }}
              >
                Edit
                <EditIcon style={{ fontSize: 16, marginLeft: 8 }} />
              </Button>}
          </div>}
      </div>
    </Dialog>
  );
}

class InfoDialogWrapper extends React.Component {
  render() {
    return (
      <InfoDialog {...this.props} />
    );
  }
}

const mapStateToProps = (state) => ({
  showEdit: (state.auth.userType === UserTypes.SUPER || state.auth.userType === UserTypes.IT) && state.setupMode.mode
});

export default connect(mapStateToProps, null)(InfoDialogWrapper);

InfoDialog.propTypes = {
  children: PropTypes.any,
  statusColor: PropTypes.string,
  header: PropTypes.any,
  footer: PropTypes.any,
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  editHref: PropTypes.string,
  showEdit: PropTypes.bool
};
